import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';

// paths start with "secure" so the api client does not prefix them with api/v1
const START_URL = 'secure/auth/phone/forgot-password/start';
const RESET_URL = 'secure/auth/phone/forgot-password/reset';

interface StartPayload {
  phone: string;
}

interface ResetPayload {
  phone: string;
  code: string;
  password: string;
  password_confirmation: string;
}

interface MessageResponse extends BackendResponse {
  message: string;
}

// reset now signs the user in, returning the same shape as login
export interface PhoneResetSessionResponse extends BackendResponse {
  bootstrapData: string;
  two_factor: false;
}

// step 1: request a verification code be sent to the phone. The response is
// intentionally the same whether or not the number is registered.
export function useStartPhonePasswordReset() {
  return useMutation({
    mutationFn: (payload: StartPayload) =>
      apiClient
        .post<MessageResponse>(START_URL, payload)
        .then(r => r.data),
  });
}

// step 2: submit the code and the new password
export function useResetPhonePassword() {
  return useMutation({
    mutationFn: (payload: ResetPayload) =>
      apiClient
        .post<PhoneResetSessionResponse>(RESET_URL, payload)
        .then(r => r.data),
  });
}
